import HeroPolicy from "@/components/common/HeroPolicy";
import Container from "@/components/layout/Container";

const Privacy = () => {
  return (
    <Container>
      <HeroPolicy />

      <main id="main-content" className="min-h-screen px-[2rem] wide:px-0">
        <div className="py-[2rem]">
          {/* Content */}
          <div className="policy-content">
            <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-4">
              스탠다드 네트웍스(주) 사이트는 고객님의 개인정보를 매우 중요시하며, 개인정보를
              보호하기 위하여 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법')과
              개인정보보호법을 준수하고 있습니다.
            </p>
            <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-10">
              본 사이트의 개인정보 취급방침은 다음과 같은 내용을 담고 있습니다. 개인정보처리방침은
              관련법령 및 지침의 변경과 회사 내부 방침에 따라 변경될 수 있으며, 개인정보처리방침을
              개정하는 경우 웹사이트 공지사항(또는 개별공지)를 통하여 공지할 것입니다.
            </p>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">
                1. 수집하는 개인정보의 항목
              </h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                회사는 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
              </p>
              <ul className="space-y-2 text-[1.5rem] text-gray-6 leading-[1.8]">
                <li>- 이름, 생년월일, 성별</li>
                <li>- 이메일, 주소</li>
                <li>- 휴대전화번호, 전화번호</li>
                <li>- 아이디, 비밀번호</li>
                <li>- 접속 로그, 쿠키, 접속 IP정보, 결제기록, 이용정지 기록</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">
                2. 개인정보의 수집 및 이용목적
              </h2>
              <ul className="space-y-2 text-[1.5rem] text-gray-6 leading-[1.8]">
                <li>
                  - 이용자, 사업자회원으로서의 신분, 주소, 연락처를 확인 등 회원제 서비스 이용에
                  따른 본인확인, 개인 식별
                </li>
                <li>- 미풍양속 저해, 서비스 악용행위, 불량회원 부정이용 방지</li>
                <li>- 스팸댓글, 광고성댓글 등 : 고객님의 입력 및 주문정보에 주변알림에 이용</li>
                <li>- 이벤트, 상금지급, 회원제 배송등에 이용</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">
                3. 개인정보의 보유 및 이용기간
              </h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                개인정보는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를
                파기합니다. 파기는 재생이 불가능한 기술적 방법을 사용합니다.
              </p>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                단, 상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여
                보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안
                회원정보를 보관합니다.
              </p>
              <ul className="space-y-2 text-[1.5rem] text-gray-6 leading-[1.8]">
                <li>
                  - 스팸메일, 광고성정보 전송의 동의 또는 철회 등에 관한 기록 : 6개월 (전자상거래법,
                  전자상거래법 시행령 제6조)
                </li>
                <li>
                  - 계약 또는 청약철회 등에 관한 기록, 표시·광고에 관한 기록 : 5년 (상법 및
                  국세기본법)
                </li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">
                4. 개인정보의 파기 절차 및 방법
              </h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이
                파기합니다.
              </p>
              <ul className="space-y-2 text-[1.5rem] text-gray-6 leading-[1.8]">
                <li>
                  - 고객님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의
                  데이터베이스(DB)로 옮겨져 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후
                  파기됩니다.
                </li>
                <li>
                  - 별도 데이터베이스(DB)로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유
                  이외의 다른 목적으로 이용되지 않습니다.
                </li>
                <li>
                  - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통해 파기하고, 전자적 파일
                  형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
                </li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">5. 개인 정보 제공</h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                회사는 원칙적으로 고객님의 개인정보를 외부에 제공하지 않습니다.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">6. 수집한 개인정보의 위탁</h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                회사는 수집된 고객님의 개인정보를 제휴업체에 위탁처리하지 않습니다.
              </p>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게
                통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">
                7. 이용자 및 법정대리인의 권리와 그 행사방법
              </h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회 및 수정할 수 있습니다.
              </p>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                이용자의 개인정보 조회/수정을 위해서는 '정보수정'을, 가입해지(동의철회)를 위해서는
                '회원가입해지'를 클릭하여 본인 확인 절차 후 직접 열람, 정정 또는 탈퇴가 가능합니다.
              </p>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                혹은 개인정보 관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이
                조치하겠습니다.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">
                8. 개인정보 자동수집 장치의 설치, 운영 및 거부에 관한 사항
              </h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                스탠다드 네트웍스(주)는 서비스의 원활한 제공을 위해 귀하의 정보를 저장하고 수시로
                찾아내는 '쿠키(cookie)'를 사용합니다.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">
                9. 개인정보의 안전성 확보 조치
              </h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                스탠다드 네트웍스는 다음과 같이 안전성 확보에 필요한 조치를 하고 있습니다.
              </p>
              <ul className="space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                <li>
                  <strong>1) 내부관리계획의 수립 및 시행</strong>
                  <br />
                  개인정보의 안전한 처리를 위하여 내부관리계획을 수립 및 시행하고 있습니다.
                </li>
                <li>
                  <strong>2) 개인정보 취급 직원의 최소화 및 교육</strong>
                  <br />
                  개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하며 개인정보를
                  관리하는 대책을 시행하고 있습니다.
                </li>
                <li>
                  <strong>3) 해킹 등에 대비한 기술적 대책</strong>
                  <br />
                  해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여
                  보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에
                  시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
                </li>
                <li>
                  <strong>4) 접근기록의 보존 및 위변조 방지</strong>
                  <br />
                  개인정보처리시스템에 접속한 기록(웹 로그, 요약정보 등)을 최소 6개월 이상 보관,
                  관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고
                  있습니다.
                </li>
                <li>
                  <strong>5) 개인정보의 암호화</strong>
                  <br />
                  이용자의 개인정보는 암호화 되어 저장 및 관리되고 있습니다.
                </li>
                <li>
                  <strong>6) 비인가자에 대한 출입 통제</strong>
                  <br />
                  개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를
                  수립, 운영하고 있습니다.
                </li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-[1.8rem] font-bold text-navy mb-4">
                10. 개인정보에 관한 민원서비스
              </h2>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와
                같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.
              </p>
              <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기
                바랍니다.
              </p>
              <ul className="space-y-2 text-[1.5rem] text-gray-6 leading-[1.8]">
                <li>1. 개인정보침해신고센터 (http://www.1336.or.kr / 1336)</li>
                <li>2. 정보보호마크인증위원회 (http://www.eprivacy.or.kr / 02-580-0533~4)</li>
                <li>3. 대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr / 02-3480-3600)</li>
                <li>4. 경찰청 사이버테러대응센터 (http://www.ctrc.go.kr / 02-392-0330)</li>
              </ul>
            </section>
          </div>
        </div>
      </main>
    </Container>
  );
};

export default Privacy;
